import axios from 'axios'
import Cookie from 'js-cookie'
import client from '@/client/modules/common'
import { SDK_PRODUCT } from '@/config/dataMap'
import { SDK_WEB_VERSION, ORIGIN_APIROOT } from '@/config/config'
import { signature } from './sign'

const productId = SDK_PRODUCT.id

const service = axios.create({
  baseURL: ORIGIN_APIROOT, // api的base_url
  timeout: 5000, // request timeout
  headers: {
    'X-Cf-Productid': productId,
    'X-Cf-Version': 1,
    'X-Cf-Authorization': ''
  }
})

// http 请求拦截器
service.interceptors.request.use(
  config => {
    const data = {
      common: {
        server_id: Cookie.get('svrid') || '',
        uuid: Cookie.get('uuid') || '',
        tryno: Cookie.get('tryno') || '',
        user_agent: 'web',
        web_version: SDK_WEB_VERSION,
        token: '',
        vip_version: Cookie.get('vip_version'),
        open_id: ''
      }
    }
    // common需要深度拷贝, 故需再次assign
    config.data = Object.assign(data, config.data, {
      common: Object.assign(
        data.common,
        (config.data && config.data.common) || {}
      )
    })
    // 处理header
    config.headers['X-Cf-Authorization'] = signature(JSON.stringify(config.data))
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// http 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data.resp_common
    // 4001002 token过期
    if (res && res.ret === 4001002) {
      const name = window.app.$route.name
      if (name !== 'login' && name !== 'login2' && name !== 'login3') {
        window.app.$toast('登录信息已过期，请重新登录')
        window.app.$store.dispatch('user/setLoginStatus', 2)
        // todo 修改方法
        client.API.exit()
        window.app.$EventBus.$emit('logout')
      }
    }
    return response.data
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
